/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { communicationV1EmailsDeleteDestroy } from '../../__generated__/oazapfts-client';
import { GetAllCommunications } from '../queries/get-all-communications';

export namespace DeleteEmail {
  export type Input = { id: string };
  export type Output = void;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const auth = useAuth();
    const me = useMe();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const accessToken = await auth.getAccessToken();

        const result = await communicationV1EmailsDeleteDestroy(
          {
            uuid: input.id,
            xUserName: me.displayName,
            xUserEmail: me.email,
          },
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (result.status !== 204) {
          throw new Error('Fail to delete meeting minutes');
        }
      },
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: GetAllCommunications.key({}),
        });
      },
    });
  }
}
